import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';

import { PRODUCTS_SYNC_FEATURE_KEY } from './keys';
import { productsSyncReducer } from './reducers/products-sync.reducer';
import { ProductsSyncEffects } from './effects/products-sync.effects';

export function provideProductsSyncStore(): EnvironmentProviders[] {
    return [provideState(PRODUCTS_SYNC_FEATURE_KEY, productsSyncReducer), provideEffects(ProductsSyncEffects)];
}
